import { useState } from 'react'

import { useOnEscPress } from './useOnEscPress'

export const useCanvas = <T>() => {
  const [canvasItem, setCanvasItem] = useState<T>()
  const [isCanvasOpen, setIsCanvasOpen] = useState(false)
  const openCanvas = () => setIsCanvasOpen(true)
  const closeCanvas = () => setIsCanvasOpen(false)

  useOnEscPress({ onEscPress: closeCanvas })

  return {
    canvasItem,
    setCanvasItem,
    isCanvasOpen,
    openCanvas,
    closeCanvas,
  }
}
